module.exports = __webpack_public_path__ + "img/icon-kmg-non-rumah.6e457acb.svg";